"use strict";var N=require("../../Coerce/enumeration.cjs").enumeration({WINDOWS_7_VERSION:"NT 6.1",WINDOWS_8_VERSION:"NT 6.2",WINDOWS_8_1_VERSION:"NT 6.3",WINDOWS_10_VERSION:"NT 10.0"});exports.WindowsVersion=N;
//# sourceMappingURL=WindowsVersion.cjs.map
